// EvidenceLadder.tsx - the four-rung evidence ladder, lit to the current street's level (L1 flop,
// L1+L2 turn, L1+L2+L3 river). Rungs at or below the level read "on" (gold); the current rung is ringed.
// Ported from the mockup #evladder / renderLadder.
const RUNGS = [
  { lvl: 1, label: 'Level 1', sub: 'one odd action' },
  { lvl: 2, label: 'Level 2', sub: 'twice, a pattern' },
  { lvl: 3, label: 'Level 3', sub: 'plus a showdown' },
  { lvl: 4, label: 'Level 4', sub: 'the player shifts' },
] as const;

export interface EvidenceLadderProps {
  /** the level lit this street (0 = none). */
  level: number;
}

export function EvidenceLadder({ level }: EvidenceLadderProps) {
  return (
    <div className="evladder">
      {RUNGS.map((r) => {
        const on = r.lvl <= level && level > 0;
        const cls = 'rung' + (on ? ' on' : '') + (r.lvl === level ? ' cur' : '');
        return (
          <div key={r.lvl} className={cls}>
            {r.label}
            <s>{r.sub}</s>
          </div>
        );
      })}
    </div>
  );
}
